import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Console, time } from 'console';
import { Observable } from 'rxjs';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { DocumentService } from 'src/app/services/document.service';
import { saveAs } from "file-saver";
import * as moment from 'moment';

@Component({
  selector: 'app-raps',
  templateUrl: './raps.component.html',
  styleUrls: ['./raps.component.scss']
})
export class RapsComponent implements OnInit {

  @Input('learner') learner;
  @Input('job') job
  @Input('selectedJob') jobId
  personalDetails: FormGroup;
  participationUndertaken: FormGroup;
  smartTargets: FormGroup;
  jobTraining: FormGroup;
  learnerFeedback: FormGroup;
  managerFeedback: FormGroup;
  learnerSign: boolean = false;
  trainerSign: boolean = false;
  employerSign: boolean = false;
  isLearner: boolean
  data
  user
  learnerName
  instructorName
  editedData
  selectedJob: any;
  loading: boolean;
  learnerFormData: any;
  singleFormDetails: any;
  isEdit: boolean;
  rapFormData: any = [];
  selectedIndex: any = 0
  selectedFormDetails: any;
  currentDate
  isDisable
  constructor(
    public dialog: MatDialog,
    public changeDetector: ChangeDetectorRef,
    public documentService: DocumentService,
    public formBuilder: FormBuilder,
    public _snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    console.log("userRole Check:", this.user)
    if (this.user && this.user.isLearner) {
      this.isLearner = this.user.isLearner

    }

    // this.getLearnerRapForm()
    // if (!this.rapFormData)
    this.createForm()

  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("%cchanges in RAPS form", "color:red", changes)
    if (changes && changes.learner) {
      this.learner = changes.learner.currentValue
      if (this.learner && this.learner.name) {
        this.learnerName = this.learner.name
        this.personalDetails.patchValue({
          name: this.learnerName
        })
      }
      console.log("HELLO IS LEARNER:", this.learnerName)
    }

    if (changes && changes.job && changes.job.currentValue) {
      this.job = changes.job.currentValue[0]
      console.log("%c job in changes", "color:purple", this.job)
      console.log("Single JOb Data For Form:===>", this.job)

      //for Instructor Name
      if (this.job && this.job.instructors && this.job.instructors.length) {
        let arrayLength = this.job.instructors.length;
        let instructorList = []

        for (var i = 0; i < arrayLength; i++) {
          instructorList.push(this.job.instructors[i].name)
        }

        this.instructorName = instructorList.join(',')

      }

      this.createForm()

      this.changeDetector.detectChanges()

    }
    if (changes.jobId && changes.jobId.currentValue) {
      this.selectedJob = changes.jobId.currentValue
      console.log("this is selected job", this.selectedJob);
    }

    this.learnerSign = false
    this.employerSign = false
    this.trainerSign = false
    this.getLearnerRapForm()
    // this.changeFormData()
  }


  // CREATE FORM

  createForm(details?) {
    console.log("details", details);
    this.personalDetails = new FormGroup({
      name: new FormControl((details && details.personalDetails) ? details.personalDetails.name : this.learnerName),
      consultantName: new FormControl((details && details.personalDetails) ? details.personalDetails.consultantName : this.instructorName),
      date: new FormControl((details && details.personalDetails) ? details.personalDetails.date : this.currentDate),
      time: new FormControl((details && details.personalDetails) ? details.personalDetails.time : ''),
      progTitle: new FormControl((details && details.personalDetails) ? details.personalDetails.progTitle : ''),
    })
    this.participationUndertaken = new FormGroup({
      review1: new FormControl((details && details.participationUndertaken) ? details.participationUndertaken.review1 : ''),
      learning: new FormControl((details && details.participationUndertaken) ? details.participationUndertaken.learning : ''),
      assessment: new FormControl((details && details.participationUndertaken) ? details.participationUndertaken.assessment : ''),
      careerDevelopment: new FormControl((details && details.participationUndertaken) ? details.participationUndertaken.careerDevelopment : ''),
      requirements: new FormControl((details && details.participationUndertaken) ? details.participationUndertaken.requirements : ''),
      attendance: new FormControl((details && details.participationUndertaken) ? details.participationUndertaken.attendance : ''),
      review2: new FormControl((details && details.participationUndertaken) ? details.participationUndertaken.review2 : ''),
      objective: new FormControl((details && details.participationUndertaken) ? details.participationUndertaken.objective : ''),
      activity: new FormControl((details && details.participationUndertaken) ? details.participationUndertaken.activity : ''),
      action: new FormControl((details && details.participationUndertaken) ? details.participationUndertaken.action : ''),
      learningFeedback: new FormControl((details && details.participationUndertaken) ? details.participationUndertaken.learningFeedback : ''),
      assessmentFeedback: new FormControl((details && details.participationUndertaken) ? details.participationUndertaken.assessmentFeedback : ''),
    })
    this.smartTargets = new FormGroup({
      learningAls1: new FormControl((details && details.smartTargets) ? details.smartTargets.learningAls1 : ''),
      learningAls2: new FormControl((details && details.smartTargets) ? details.smartTargets.learningAls2 : ''),
      date1: new FormControl((details && details.smartTargets) ? details.smartTargets.date1 : ''),
      date2: new FormControl((details && details.smartTargets) ? details.smartTargets.date2 : ''),
      assessment1: new FormControl((details && details.smartTargets) ? details.smartTargets.assessment1 : ''),
      assessment2: new FormControl((details && details.smartTargets) ? details.smartTargets.assessment2 : ''),
      date3: new FormControl((details && details.smartTargets) ? details.smartTargets.date3 : ''),
      date4: new FormControl((details && details.smartTargets) ? details.smartTargets.date4 : ''),
      careerDevelopment1: new FormControl((details && details.smartTargets) ? details.smartTargets.careerDevelopment1 : ''),
      careerDevelopment2: new FormControl((details && details.smartTargets) ? details.smartTargets.careerDevelopment2 : ''),
      date5: new FormControl((details && details.smartTargets) ? details.smartTargets.date5 : ''),
      date6: new FormControl((details && details.smartTargets) ? details.smartTargets.date6 : ''),
    })
    this.jobTraining = new FormGroup({
      completed: new FormControl((details && details.jobTraining) ? details.jobTraining.completed : ''),
      planned: new FormControl((details && details.jobTraining) ? details.jobTraining.planned : ''),
      select1_1: new FormControl((details && details.jobTraining) ? details.jobTraining.select1_1 : ''),
      select1_2: new FormControl((details && details.jobTraining) ? details.jobTraining.select1_2 : ''),
      select1_3: new FormControl((details && details.jobTraining) ? details.jobTraining.select1_3 : ''),
      select1_4: new FormControl((details && details.jobTraining) ? details.jobTraining.select1_4 : ''),
      select2_1: new FormControl((details && details.jobTraining) ? details.jobTraining.select2_1 : ''),
      select2_2: new FormControl((details && details.jobTraining) ? details.jobTraining.select2_2 : ''),
      select2_3: new FormControl((details && details.jobTraining) ? details.jobTraining.select2_3 : ''),
      select2_4: new FormControl((details && details.jobTraining) ? details.jobTraining.select2_4 : ''),
      select3_1: new FormControl((details && details.jobTraining) ? details.jobTraining.select3_1 : ''),
      select3_2: new FormControl((details && details.jobTraining) ? details.jobTraining.select3_2 : ''),
      select3_3: new FormControl((details && details.jobTraining) ? details.jobTraining.select3_3 : ''),
      select4_1: new FormControl((details && details.jobTraining) ? details.jobTraining.select4_1 : ''),
      select4_2: new FormControl((details && details.jobTraining) ? details.jobTraining.select4_2 : ''),
      select4_3: new FormControl((details && details.jobTraining) ? details.jobTraining.select4_3 : ''),
      discussion1: new FormControl((details && details.jobTraining) ? details.jobTraining.discussion1 : ''),
      discussion2: new FormControl((details && details.jobTraining) ? details.jobTraining.discussion2 : ''),
      discussion3: new FormControl((details && details.jobTraining) ? details.jobTraining.discussion3 : ''),
      discussion4: new FormControl((details && details.jobTraining) ? details.jobTraining.discussion4 : ''),
    })
    this.learnerFeedback = new FormGroup({
      confidence1: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.confidence1 : ''),
      confidence2: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.confidence2 : ''),
      confidence3: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.confidence3 : ''),
      confidence4: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.confidence4 : ''),
      confidence5: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.confidence5 : ''),
      resilience1: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.resilience1 : ''),
      resilience2: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.resilience2 : ''),
      resilience3: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.resilience3 : ''),
      resilience4: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.resilience4 : ''),
      resilience5: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.resilience5 : ''),
      stress1: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.stress1 : ''),
      stress2: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.stress2 : ''),
      stress3: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.stress3 : ''),
      stress4: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.stress4 : ''),
      stress5: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.stress5 : ''),
      overall: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.overall : ''),
      comment: new FormControl((details && details.learnerFeedback) ? details.learnerFeedback.comment : ''),
    })
    this.managerFeedback = new FormGroup({
      punctuality1: new FormControl((details && details.managerFeedback) ? details.managerFeedback.punctuality1 : ''),
      punctuality2: new FormControl((details && details.managerFeedback) ? details.managerFeedback.punctuality2 : ''),
      punctuality3: new FormControl((details && details.managerFeedback) ? details.managerFeedback.punctuality3 : ''),
      punctuality4: new FormControl((details && details.managerFeedback) ? details.managerFeedback.punctuality4 : ''),
      punctuality5: new FormControl((details && details.managerFeedback) ? details.managerFeedback.punctuality5 : ''),
      attendance1: new FormControl((details && details.managerFeedback) ? details.managerFeedback.attendance1 : ''),
      attendance2: new FormControl((details && details.managerFeedback) ? details.managerFeedback.attendance2 : ''),
      attendance3: new FormControl((details && details.managerFeedback) ? details.managerFeedback.attendance3 : ''),
      attendance4: new FormControl((details && details.managerFeedback) ? details.managerFeedback.attendance4 : ''),
      attendance5: new FormControl((details && details.managerFeedback) ? details.managerFeedback.attendance5 : ''),
      overall: new FormControl((details && details.managerFeedback) ? details.managerFeedback.overall : ''),
      comment: new FormControl((details && details.managerFeedback) ? details.managerFeedback.comment : ''),
      learnerDate: new FormControl((details && details.managerFeedback) ? details.managerFeedback.learnerDate : ''),
      trainerDate: new FormControl((details && details.managerFeedback) ? details.managerFeedback.trainerDate : ''),
      employerDate: new FormControl((details && details.managerFeedback) ? details.managerFeedback.employerDate : ''),
      learnerSign: new FormControl((details && details.managerFeedback) ? details.managerFeedback.learnerSign : ''),
      trainerSign: new FormControl((details && details.managerFeedback) ? details.managerFeedback.trainerSign : ''),
      employerSign: new FormControl((details && details.managerFeedback) ? details.managerFeedback.employerSign : ''),
    })
  }



  // UTILITY FUNCTION

  changeEvent(event, id, index) {
    console.log("event", event);
    console.log("id", id);
    console.log("handToolFormData", this.rapFormData);
    console.log("index", index);
    this.selectedIndex = this.rapFormData[index]._id
    this.singleFormDetails = this.rapFormData[index]
    this.changeFormData()
  }

  changeFormData() {
    this.isEdit = true
    console.log("this.singleFormDetails", this.singleFormDetails);

    if (this.singleFormDetails && this.singleFormDetails.details && this.singleFormDetails.details.managerFeedback.learnerSign != '') {
      console.log("Sign run........")
      this.learnerSign = true
    } else this.learnerSign = false

    if (this.singleFormDetails && this.singleFormDetails.details && this.singleFormDetails.details.managerFeedback.employerSign != '') {
      this.employerSign = true
    } else this.employerSign = false

    if (this.singleFormDetails && this.singleFormDetails.details && this.singleFormDetails.details.managerFeedback.trainerSign != '') {
      this.trainerSign = true
    } else this.trainerSign = false

    if (this.singleFormDetails && this.singleFormDetails.details)
      this.createForm(this.singleFormDetails.details)
  }

  addSignature(fomrControl) {

    console.log("form control name", fomrControl);
    this.openDialog(SignaturePadComponent).subscribe((data) => {
      console.log("what is the value of sig", data);
      if (data == undefined) return data
      let sign = data
      if (fomrControl == 'learnerSign') {
        this.learnerSign = true
        this.managerFeedback.patchValue({
          learnerSign: sign
        })
      } else if (fomrControl == 'trainerSign') {
        this.trainerSign = true
        this.managerFeedback.patchValue({
          trainerSign: sign
        })
      } else if (fomrControl == 'employerSign') {
        this.employerSign = true
        this.managerFeedback.patchValue({
          employerSign: sign
        })
      }
    })
  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'personalDetails')
      this.personalDetails.get(formControl).setValue(value);
    else if (formGroup == 'smartTargets')
      this.smartTargets.get(formControl).setValue(value);
    else if (formGroup == 'managerFeedback')
      this.managerFeedback.get(formControl).setValue(value);
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }
  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  addNewForm() {
    let obj = {
      updatedAt: this.currentDate,
      _id: 'static'
    }
    this.selectedIndex = 'static'
    this.learnerSign = false;
    this.trainerSign = false;
    this.employerSign = false;
    this.rapFormData.push(obj)
    this.createForm({ personalDetails: { date: this.currentDate, name: this.learnerName, consultantName: this.instructorName } })
    this.isEdit = false
  }

  downloadRapForm() {
    this.loading = true

    console.log("download click");
    let details = {
      personalDetails: this.personalDetails.value,
      participationUndertaken: this.participationUndertaken.value,
      smartTargets: this.smartTargets.value,
      jobTraining: this.jobTraining.value,
      learnerFeedback: this.learnerFeedback.value,
      managerFeedback: this.managerFeedback.value,
      templateName: 'rap-form'
    }
    this.documentService.downloadLearnerForm(details).subscribe((res) => {
      console.log("res", res);
      this.loading = false

    }, (error) => {
      this.loading = false
      console.log("reponse failed download ilp form", error);
    })
  }

  // API CALL

  getLearnerRapForm() {
    this.loading = true
    console.log("selected learner id", this.learner);
    console.log("selected job id", this.selectedJob);
    if (this.learner != undefined && this.selectedJob != undefined) {
      let obj = {
        learner: this.learner._id,
        jobId: this.selectedJob
      }
      console.log("obj to be send", obj);
      this.documentService.getLearnerRapForm(JSON.stringify(obj)).subscribe((response: any) => {
        console.log("what response get in rap form", response.currentDate)
        this.currentDate = response.currentDate
        if (response.data && response.data.length) {
          this.isEdit = true
          this.rapFormData = response.data
          this.selectedIndex = this.rapFormData[0]._id
          this.learnerFormData = this.rapFormData[0].details
          this.singleFormDetails = this.rapFormData[0]
          this.loading = false
          this.isEdit = true
          this.isDisable = true
          if (this.learnerFormData && this.learnerFormData.managerFeedback && this.learnerFormData.managerFeedback.learnerSign != '') {
            console.log("Sign run........")
            this.learnerSign = true
          } else this.learnerSign = false

          if (this.learnerFormData && this.learnerFormData.managerFeedback && this.learnerFormData.managerFeedback.employerSign != '') {
            this.employerSign = true
          } else this.employerSign = false

          if (this.learnerFormData && this.learnerFormData.managerFeedback && this.learnerFormData.managerFeedback.trainerSign != '') {
            this.trainerSign = true
          } else this.trainerSign = false

          this.createForm(this.learnerFormData)
          this.changeFormData()
        } else {
          this.createForm()
          this.isDisable = false
        }
        this.loading = false
      }, error => {
        console.log("error while get RAP form", error);
        this.loading = false
      })
    }
  }

  downloadAllRapForm() {
    this.loading = true
    let obj = {
      learner: this.learner._id,
      jobId: this.jobId,
      title: 'RAP'
    }
    this.openSnackBar("Download will start automatically.", "Ok");
    this.documentService.downloadAllRaps(obj).subscribe((res) => {
      console.log("response get with merged url", res);
      if (res && res.data) {
        let title
        title = name + '_rap' + '_' + moment(new Date).format("DD-MM-YYYY") + '.pdf'
        saveAs(res.data, title);
        this.openSnackBar("PDF downloaded successfully!", "Ok");
      } else {
        console.log("this is the another response");
        this.openSnackBar(res.msg, "Ok");
      }
      this.loading = false
    })

  }



  onSubmit() {
    this.loading = true
    if (this.isEdit == true) {
      let obj = {
        metaObj: {
          title: 'RAP',
        },
        learnerId: this.learner._id,
        jobId: this.jobId,
        onModel: 'job',
        documentMetaId: this.singleFormDetails.documentMetaId._id,
        documentId: this.singleFormDetails._id,
        details: {}
      }
      let details = {
        personalDetails: this.personalDetails.value,
        participationUndertaken: this.participationUndertaken.value,
        smartTargets: this.smartTargets.value,
        jobTraining: this.jobTraining.value,
        learnerFeedback: this.learnerFeedback.value,
        managerFeedback: this.managerFeedback.value,
      }
      obj['details'] = details
      console.log("this is for edit ", obj);

      this.documentService.updateForm(obj).subscribe((response) => {
        console.log("response of RAP form", response);
        this.handleSnackBar({ msg: "Data saved successfully!", button: "Ok" });
        this.getLearnerRapForm()
        this.loading = false
      }, error => {
        console.log("error while update form", error);
        this.loading = false
        this.handleSnackBar({ msg: "Something went wrong!", button: "Ok" });
      })
    } else {
      let obj = {
        metaObj: {
          title: 'RAP',
        },
        learnerId: this.learner._id,
        jobId: this.jobId,
        onModel: 'job',
        details: {}
      }

      let details = {
        personalDetails: this.personalDetails.value,
        participationUndertaken: this.participationUndertaken.value,
        smartTargets: this.smartTargets.value,
        jobTraining: this.jobTraining.value,
        learnerFeedback: this.learnerFeedback.value,
        managerFeedback: this.managerFeedback.value,
      }
      obj['details'] = details
      console.log("this is for first time add", obj);

      this.documentService.addDocument(obj).subscribe((response) => {
        console.log("document resposne of iqa form", response);
        this.getLearnerRapForm()
        this.handleSnackBar({ msg: "Data saved successfully!", button: "Ok" });
        this.loading = false
      }, error => {
        console.log("error while add iqa form", error);
        this.loading = false
        this.handleSnackBar({ msg: "Something went wrong!", button: "Ok" });
      })
    }
  }
}
